import { FC } from 'react';
import { useUtils } from '../../../../core/hooks/useUtils';

import { RenderSnap } from '../render-snap';

const FeedList: FC<{ activeTab: string }> = ({ activeTab }) => {
	const {
		store: {
			charts: { data },
		},
	} = useUtils();

	return <RenderSnap data={data} activeTab={activeTab} />;
};

export default FeedList;
